import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "refresh"
const RefreshIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M9.404 3.382C11.544 2.738 13.847 2.912 15.866 3.872 17.884 4.832 19.473 6.51 20.323 8.577L18.936 9.147C18.228 7.425 16.904 6.027 15.222 5.227S11.62 4.281 9.837 4.82C8.053 5.356 6.533 6.539 5.573 8.134 4.613 9.73 4.281 11.627 4.643 13.454 5.002 15.28 6.03 16.909 7.525 18.02S10.876 19.645 12.73 19.464 16.304 18.418 17.555 17.038 19.5 13.863 19.5 12H21C21 14.235 20.168 16.39 18.667 18.046S15.1 20.74 12.877 20.958 8.427 20.557 6.632 19.224 3.604 15.937 3.171 13.744C2.737 11.553 3.136 9.277 4.288 7.362S7.263 4.027 9.404 3.382" />
          <path d="M21 3.75V9.75H15V8.25H19.5V3.75z" />
        </svg>
      }
    </span>
  )
}
export default RefreshIcon
